export default "__VITE_ASSET__DtjGbZIO__"